///////////// WAŻNE /////////////
import "babel-polyfill"; // To musi zostać na górze tego pliku, bo inaczej nie będzie działąć support dla IE11
import Vue from "vue";
import "./plugins/vuetify";
import "./plugins/vuetify-confirm";
import App from "./App.vue";
import router from "./router/routes.js";
import store from "./store/store.js";
import VueMeta from "vue-meta";
import VeeValidate, { Validator } from "vee-validate";
//VeeValidate - błędy po polsku
import pl from "vee-validate/dist/locale/pl";

import { role } from "./utils/Role";

import VueResource from "vue-resource";

import customCalendar from "./view/logged/form/components/CustomCalendar";

import customAttachment from "./view/logged/form/components/CustomAttachment";

import customTextArea from "./view/logged/form/components/CustomTextArea";

import customTable from "./view/logged/form/components/CustomTable";

import PrettyJSON from "./utils/PrettyJSON";
import { Files } from '@/utils/Files';
import VueKeyCloak from "@dsb-norge/vue-keycloak-js";

///////////// WAŻNE /////////////


Vue.config.productionTip = false;

Vue.use(VueResource);
Vue.use(VueMeta);
Vue.use(VeeValidate, {
	locale: "pl",
	fieldsBagName: "inputs ", errorBagName: "vErrors",
});

// Rejestracja komponentu customowego pola kalendarze, załacznika oraz textArea
// Musi on mieć prefix field-, bo inaczej nie będzie działać
Vue.component("field-customCalendar", customCalendar);
Vue.component("field-customAttachment", customAttachment);
Vue.component("field-customTextArea", customTextArea);
Vue.component("field-customTable", customTable);
Vue.component('pretty-json', PrettyJSON);

Validator.localize("pld", pl);


// Dodawanie do nagłówka tokena przed requestem na serwer
Vue.http.interceptors.push(function (request, next) {
	if (sessionStorage["access_token"] !== undefined) {
		request.headers.set("Authorization", "Bearer " + sessionStorage["access_token"]);
	}
	if (this && this.$route !== undefined && this.$route.query !== undefined && this.$route.query["auth_token"] !== undefined) {
		request.headers.set("Authorization", "Bearer " + this.$route.query["auth_token"]);
	}

	// Wlaczenie spinner
	next(() => {
	});
});

// obiekt role jest dostępny we wszystkich komponentach Vue jako read only
// służy do autoryzacji poszczególnych zasobów w konkretnym widoku
Vue.mixin({
	data: function () {
		return {
			get roles() {
				return role;
			},
			get acceptedFiles() {
				return ".pdf,.rar,.zip,.7z,.doc,.docx,.rtf,.xls,.xlsx,.jpg,.jpeg,.tiff,.gif,.png,.msg";
			}
		};
	},
	methods: {
		hasIncorrectFilesExtension(filesArray) {
			if (filesArray === null || filesArray.length < 1) {
				return true;
			}
			for (let i = 0; i < filesArray.length; i++) {
				if (!this.acceptedFiles.includes(Files.methods.getFileExtension(filesArray[i].name).toLowerCase())) {
					return true;
				}
			}
			return false;
		},

		hasNonRtfFileExtension(filesArray) {
			if (filesArray === null || filesArray.length < 1) {
				return true;
			}
			if (filesArray.length > 1) {
				return true;
			}
			return ".rtf" !== Files.methods.getFileExtension(filesArray[0].name).toLowerCase();
		}
	}
});

// Autoryzacja widoków po stronie frontedu
router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.requiresAuth)) {
		if (Vue.prototype.$keycloak.authenticated) {
			// store.commit("clearDataTableFilters");
			// store.commit("clearDataTablePagination");
			sessionStorage["access_token"] = Vue.prototype.$keycloak.token;
			sessionStorage["expiration"] = Vue.prototype.$keycloak.tokenParsed.exp + Vue.prototype.$keycloak.timeSkew - new Date().getTime() / 1000;
			Vue.http.get(process.env.VUE_APP_API_URL + "/user/user-system-role").then(response => {
				sessionStorage["role"] = response.data.role;
				next();
			});
		} else {
			Vue.prototype.$keycloak.login({ redirectUri: document.location.href });
		}
	} else {
		next();
	}
});

// Zmiana nazwy zakładki
const DEFAULT_PAGE_TITLE = 'eGranty';
router.afterEach((to) => {
	Vue.nextTick(() => {
		document.title = to.meta.title ? DEFAULT_PAGE_TITLE + ' - ' + to.meta.title : DEFAULT_PAGE_TITLE;
	});
});

// Kanał do przesyłania messages wyświetlanych użytkownikowi
Vue.prototype.$messagesBus = new Vue();

function startVue() {
	new Vue({
		router,
		store,
		render: h => h(App),
	}).$mount("#app");
}

if (document.location.href.includes('/print/LrZ63OJBjtb4Iii5sBuRDC2X8JlygwCcIiehxloouW4RqqTtS0djoXr75zGeEUXh')) {
	startVue();
} else {
	Vue.use(VueKeyCloak, {
		config: {
			realm: 'egranty',
			url: process.env.VUE_APP_AUTH_URL,
			clientId: 'login-app'
		},
		init: {
			onLoad: 'check-sso',
			checkLoginIframe: false
		},
		onReady: kc => {
			startVue();
		}
	});
}